import React from 'react'
import injectStyles from 'react-jss'

const styles = {
  note: {
    display: 'block',
    top: 2,
    right: 2,
    position: 'absolute',
    fontSize: 12,
    color: '#cccccc',
  },
}

const UnstyledNote = ({ classes, children, ...otherProps }) => (
  <span className={classes.note} {...otherProps}>
    {children}
  </span>
)

const Note = injectStyles(styles)(UnstyledNote)

export default Note



// WEBPACK FOOTER //
// ./src/Components/Stats/BulletChart/Note.js